import '.bt{font-weight:500;}.ssr-plugin'
import { CardWrapper } from '@app/components/blocks/card/CardWrapper'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Text } from '@app/components/core/typography/Text'
import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import useDateFormat from '@app/util/useDateFormat'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'
import { ConversationAvatar } from './ConversationAvatar'
import useMediaQuery from '@app/util/useMediaQuery'

export type ConversationCardProps = {
  subject: string
  recipientName: string
  recipientAvatar?: string
  initiativeTitle?: string
  initiativeImage?: string
  lastMessage: Date
  hasNewMessages: boolean
  isOpen: boolean
  onClick: VoidFunction
}

export const ConversationCard = ({
  subject,
  recipientName,
  recipientAvatar,
  initiativeTitle,
  initiativeImage,
  lastMessage,
  hasNewMessages,
  isOpen,
  onClick,
}: ConversationCardProps) => {
  const isMobile = useMediaQuery()
  const format = useDateFormat(false, true)
  const translations = useTranslations().app.dashboard.messages
  const fontColor = hasNewMessages
    ? 'var(--primary-blue)'
    : 'var(--shades-blue-500)'
  return (
    <CardWrapper
      padding={'1.5rem'}
      onClick={onClick}
      style={{
        border: `1px solid ${isOpen ? 'var(--primary-blue)' : hasNewMessages ? 'var(--gray-200)' : 'var(--gray-100)'}`,
        background: hasNewMessages ? 'var(--gray-100)' : 'var(--shades-white)',
      }}
    >
      <Column alignItems="stretch">
        <Title.H5
          style={{
            color: fontColor,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {subject}
        </Title.H5>
        <Row
          gap={'0.5rem'}
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Row
            gap={'0.5rem'}
            style={{
              alignItems: 'center',
            }}
          >
            {initiativeTitle ? (
              <ConversationAvatar
                initiativeImage={initiativeImage}
                userAvatar={recipientAvatar}
                userName={recipientName}
              />
            ) : (
              <Avatar
                size="small"
                shape="circle"
                labelSource={recipientName}
                image={recipientAvatar}
              />
            )}
            <Column gap={0}>
              <Text.Medium isBold color={fontColor}>
                {recipientName}
              </Text.Medium>
              {initiativeTitle && (
                <Text.Medium color={fontColor}>
                  {translations.from}{' '}
                  <span className="bt"
                  >
                    {initiativeTitle}
                  </span>
                </Text.Medium>
              )}
              {isMobile && (
                <Text.ExtraSmall color="var(--shades-blue-300)">
                  {format(lastMessage)}
                </Text.ExtraSmall>
              )}
            </Column>
          </Row>
          {!isMobile && (
            <Text.ExtraSmall color="var(--shades-blue-300)">
              {format(lastMessage)}
            </Text.ExtraSmall>
          )}
        </Row>
      </Column>
    </CardWrapper>
  )
}
